import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import Paragraph from "@scentregroup/ui/components/paragraph";
import Icon from "@scentregroup/ui/components/icon";
import StarRating from '../../star-rating';
import ShowMoreText from '../../show-more-text';
import { reviewType } from '../types';
import styles from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_STARS = 5;

const mapSourceIdToSourceName = sourceId => ({
  GOOGLE_PLACES: 'Google Maps'
})[sourceId];

const ariaLabelForRating = (rating, name) => "".concat(rating, " star review by ").concat(name);

const Review = ({
  name,
  date,
  comment,
  rating,
  sourceId,
  responses,
  color,
  centreTitle
}) => {
  const response = responses && responses[0];
  const responder = centreTitle || 'Replied';
  const iconWrapperClassNames = classNames(styles.iconWrapper, {
    [styles.greyIconWrapper]: color === 'White'
  });
  return /*#__PURE__*/_jsxs("div", {
    role: "listitem",
    "aria-label": ariaLabelForRating(rating, name),
    "aria-roledescription": "review",
    className: styles.review,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.summary,
      children: [/*#__PURE__*/_jsx("div", {
        className: iconWrapperClassNames,
        children: /*#__PURE__*/_jsx(Icon, {
          type: "user",
          size: "medium",
          className: styles.icon
        })
      }), /*#__PURE__*/_jsxs(Paragraph, {
        className: styles.user,
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.userName,
          children: name
        }), /*#__PURE__*/_jsxs("span", {
          className: styles.source,
          children: [' on ', mapSourceIdToSourceName(sourceId)]
        })]
      }), /*#__PURE__*/_jsxs(Paragraph, {
        className: styles.info,
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.date,
          children: moment(date).fromNow()
        }), /*#__PURE__*/_jsx("span", {
          className: styles.starRating,
          children: /*#__PURE__*/_jsx(StarRating, {
            starRating: rating,
            starTotal: MAX_STARS
          })
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.comment,
      children: /*#__PURE__*/_jsxs(ShowMoreText, {
        minLines: 3,
        buttonStyle: styles.buttonStyle,
        color: color,
        children: [/*#__PURE__*/_jsx(Paragraph, {
          children: comment
        }), response && /*#__PURE__*/_jsxs("div", {
          className: styles.response,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.responseHeading,
            children: [/*#__PURE__*/_jsx("div", {
              className: iconWrapperClassNames,
              children: /*#__PURE__*/_jsx(Icon, {
                type: "westfield-w",
                size: "medium",
                className: styles.icon
              })
            }), /*#__PURE__*/_jsxs(Paragraph, {
              className: styles.westfieldName,
              children: ["Westfield ", responder]
            })]
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: response.comment
          })]
        })]
      })
    })]
  });
};

export default Review;